import React, { useState, useEffect } from "react";
import "./Testimonials.css";

// Nombre d'images à afficher (ex : 6 images = 1.jpg à 6.jpg dans /public/testimonials/)
const numberOfImages = 6;

const testimonials = Array.from({ length: numberOfImages }, (_, i) => ({
  img: `/images/temoignage (${i + 1}).jpeg`,
}));

const Testimonials = () => {
  const [current, setCurrent] = useState(0);

  // Autoplay : change d'image toutes les 3 secondes
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 3000); // 3000 ms = 3s

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel-container">
      <div className="carousel-slide">
        <img
          src={testimonials[current].img}
          alt={`Témoignage ${current + 1}`}
        />
      </div>
    </div>
  );
};

export default Testimonials;
